import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './i18n/translations.en-us.json';
import frCA from './i18n/translations.fr-ca.json';

i18n.use(initReactI18next).init({
  resources: { en: { translation: en }, 'fr-CA': { translation: frCA } },
  lng: 'en',
  fallbackLng: 'en',
});

export default i18n;